import React from 'react';
import { Typography, Progress, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { PasswordHelper, PasswordStrength } from '../../helpers/password.helper';
import './PasswordRequirements.less';

const { Text } = Typography;

interface PasswordRequirementsProps {
  password: string;
  showProgress?: boolean;
  showRequirements?: boolean;
  compact?: boolean;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password = '',
  showProgress = true,
  showRequirements = true,
  compact = false
}) => {
  const validation: PasswordStrength = PasswordHelper.validatePassword(password);
  const progressPercent = password.trim().length > 0 ? 100 : 0; // Show 100% if any password is entered

  if (compact) {
    return (
      <div className="password-requirements-compact">
        {showProgress && (
          <Space align="center" size={8}>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              Password strength:
            </Text>
            <Progress
              size="small"
              percent={progressPercent}
              strokeColor={PasswordHelper.getStrengthColor(validation.strength)}
              showInfo={false}
              style={{ minWidth: '60px' }}
            />
            <Text 
              style={{ 
                fontSize: '12px',
                color: PasswordHelper.getStrengthColor(validation.strength),
                fontWeight: 500
              }}
            >
              {PasswordHelper.getStrengthText(validation.strength)}
            </Text>
          </Space>
        )}
      </div>
    );
  }

  return (
    <div className="password-requirements">
      {showProgress && password.length > 0 && (
        <div className="password-strength">
          <Space align="center" size={8} style={{ marginBottom: '8px' }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              Password strength:
            </Text>
            <Progress
              size="small"
              percent={progressPercent}
              strokeColor={PasswordHelper.getStrengthColor(validation.strength)}
              showInfo={false}
              style={{ minWidth: '100px' }}
            />
            <Text 
              style={{ 
                fontSize: '12px',
                color: PasswordHelper.getStrengthColor(validation.strength),
                fontWeight: 500
              }}
            >
              {PasswordHelper.getStrengthText(validation.strength)}
            </Text>
          </Space>
        </div>
      )}

      {showRequirements && password.trim().length > 0 && (
        <div className="password-requirements-list">
          <Text 
            style={{ 
              fontSize: '12px', 
              display: 'block', 
              marginBottom: '4px',
              color: '#52c41a'
            }}
          >
            ✓ Password accepted - no format restrictions
          </Text>
        </div>
      )}
    </div>
  );
};

export default PasswordRequirements;